/* The Collector Edit — cart-drawer Collector's Circle comparison (Rebag-style).
   Mounts into #ce-cc-mount (below the Cart header). Ticking "The Circle" ADDS the
   $39/mo membership subscription to the cart (variant 48630317646007, selling plan
   2875392183); the live "Collector's Circle 5%" discount function then takes 5% off
   the eligible items, so the cart total really drops. Unticking removes it.
   Defaults to UNCHECKED — we never auto-add a recurring charge. */
(function () {
  'use strict';
  var MEMBERSHIP_VARIANT = 48630317646007;
  var SELLING_PLAN = 2875392183;

  var YES = '<svg viewBox="0 0 12 9" width="11" aria-label="Yes"><path d="M11 1L4.125 8 1 4.82" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var NO = '<svg viewBox="0 0 14 14" width="11" aria-label="No"><path d="M3.5 3.5l7 7M10.5 3.5l-7 7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var BENEFITS = [
    '5% off everything, combinable with sales',
    '48-hour early access &amp; member drops',
    'Free expedited shipping (1st order/mo)',
    'Personal concierge sourcing'
  ];
  var lastCart = null, busy = false;
  // Prechecked: auto-add the membership once per session when the cart has a real item.
  // After the first auto-add (or any removal), we don't re-add, so unticking sticks for
  // the session; a new session prechecks again.
  // Conversion test (11 Aug 2026): membership is OPT-IN. Set back to true to
  // restore the pre-ticked behaviour - nothing else needs changing.
  var CC_AUTO_ADD = false;

  function autoAddDone() { try { return sessionStorage.getItem('ce_cc_auto') === '1'; } catch (e) { return false; } }
  function markAutoAdd() { try { sessionStorage.setItem('ce_cc_auto', '1'); } catch (e) {} }

  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
  function isMembership(it) { return (it.product_type || '') === 'Membership'; }
  function isExtra(it) { return (it.title || '').indexOf('Shipping Protection') > -1 || isMembership(it); }
  function subtotal(c) { var t = 0; c.items.forEach(function (i) { if (!isExtra(i)) t += i.final_line_price; }); return t / 100; }
  function realCount(c) { return c.items.filter(function (i) { return !isExtra(i); }).length; }
  function membershipInCart(c) { return !!(c && c.items && c.items.some(isMembership)); }
  function membershipKey(c) { var it = c && c.items && c.items.filter(isMembership)[0]; return it && it.key; }
  function realQty(c) { var n = 0; if (c && c.items) c.items.forEach(function (i) { if (!isExtra(i)) n += i.quantity; }); return n; }
  function updateBubble() {
    if (!lastCart) return;
    var n = realQty(lastCart);
    var txt = n > 0 ? (n < 100 ? String(n) : '99+') : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { if (el.textContent.trim() !== txt) el.textContent = txt; el.classList.toggle('hidden', n === 0); });
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', n === 0); });
  }

  function html() {
    var rows = BENEFITS.map(function (b) {
      return '<tr><th>' + b + '</th>' +
        '<td class="ce-cct__c ce-cct__c-std"><span class="ce-cct__mark no">' + NO + '</span></td>' +
        '<td class="ce-cct__c ce-cct__c-cir"><span class="ce-cct__mark yes">' + YES + '</span></td></tr>';
    }).join('');
    return '' +
      '<div class="ce-cct">' +
        '<div class="ce-cct__head">' +
          '<label class="ce-cct__check">' +
            '<input type="checkbox" data-cc-box>' +
            '<span class="ce-cct__head-t">Save 5% with The Collector’s Circle <svg viewBox="0 0 28 28" width="15" height="15" fill="none" aria-hidden="true" style="display:inline-block;vertical-align:-3px;margin-left:3px"><circle cx="14" cy="14" r="12.4" stroke="currentColor" stroke-width="1.5" stroke-dasharray="71 7" transform="rotate(-66 14 14)"></circle><circle cx="22.8" cy="5.2" r="2.5" fill="currentColor"></circle><text x="13.5" y="14" text-anchor="middle" dominant-baseline="central" style="font-family:var(--font-heading--family,Newsreader,Georgia,serif);font-size:16.5px;font-weight:700;fill:currentColor;">C</text></svg></span>' +
          '</label>' +
          '<button type="button" class="ce-cct__toggle" data-cct-toggle aria-expanded="false" aria-label="Show comparison"><span class="ce-cct__chev"></span></button>' +
        '</div>' +
        '<div class="ce-cct__body" style="display:none">' +
          '<table class="ce-cct__table">' +
            '<colgroup><col class="ce-cct__col-l"><col class="ce-cct__col-v"><col class="ce-cct__col-v"></colgroup>' +
            '<thead><tr>' +
              '<th></th>' +
              '<th class="ce-cct__c ce-cct__c-std"><button type="button" class="ce-cct__sel is-on" data-cc-member="0"><span class="ce-cct__box"></span>Standard</button></th>' +
              '<th class="ce-cct__c ce-cct__c-cir"><button type="button" class="ce-cct__sel" data-cc-member="1"><span class="ce-cct__box"></span>The Circle</button></th>' +
            '</tr></thead><tbody>' + rows +
              '<tr class="ce-cct__price"><th>Price for your item(s)</th>' +
                '<td class="ce-cct__c ce-cct__c-std"><span class="ce-cct__pp" data-cc-std>—</span></td>' +
                '<td class="ce-cct__c ce-cct__c-cir"><span class="ce-cct__pp ce-cct__pp--c" data-cc-mem>—</span></td></tr>' +
            '</tbody></table>' +
            '<p class="ce-cct__note" data-cc-note></p>' +
        '</div>' +
      '</div>';
  }

  function ensureTable() {
    // Always show the Circle tab — even for empty or membership-only carts — so a buyer
    // who joined from the membership page sees their membership state, not a blank cart.
    var mount = document.getElementById('ce-cc-mount');
    if (!mount || !lastCart) { if (mount) mount.innerHTML = ''; return; }
    if (!mount.querySelector('.ce-cct')) mount.innerHTML = html();
  }
  function applyState() {
    var tbl = document.querySelector('#ce-cc-mount .ce-cct'); if (!tbl) return;
    var on = membershipInCart(lastCart);
    tbl.classList.toggle('is-member', on);
    tbl.classList.toggle('is-busy', busy);
    var box = tbl.querySelector('[data-cc-box]'); if (box) box.checked = on;
    tbl.querySelectorAll('.ce-cct__sel[data-cc-member]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-cc-member') === (on ? '1' : '0')); });
    if (lastCart) {
      var nReal = realCount(lastCart);
      var sub = subtotal(lastCart);
      var s = tbl.querySelector('[data-cc-std]'), m = tbl.querySelector('[data-cc-mem]');
      if (s) s.textContent = money(sub);
      if (m) m.textContent = money(Math.round(sub * 0.95 * 100) / 100);
      var priceRow = tbl.querySelector('.ce-cct__price');
      if (priceRow) priceRow.style.display = nReal > 0 ? '' : 'none';
      // empty cart: keep the Circle accordion permanently expanded
      if (nReal === 0) {
        var tgl = tbl.querySelector('[data-cct-toggle]');
        var bod = tbl.querySelector('.ce-cct__body');
        if (tgl) tgl.setAttribute('aria-expanded', 'true');
        if (bod) bod.style.display = '';
      }
      var note = tbl.querySelector('[data-cc-note]');
      if (note) {
        var more = ' <a href="/pages/membership">Learn more</a>';
        if (on && nReal > 0) {
          note.innerHTML = 'The Collector\u2019s Circle is added \u2014 $39/month for 5% off every order, 48-hour early access &amp; member perks. Cancel anytime, or untick to remove.' + more;
        } else if (on && nReal === 0) {
          note.innerHTML = 'Your Circle membership is in the cart \u2014 $39/month. Add pieces to your cart and your 5% member discount applies to them instantly. Untick to remove.' + more;
        } else if (!on && nReal === 0) {
          note.innerHTML = 'Add items to your cart to join The Collector\u2019s Circle \u2014 5% off every order, 48-hour early access &amp; member perks.' + more;
        } else {
          note.innerHTML = 'Tick The Circle to join \u2014 $39/month for 5% off this order and every order after, plus early access &amp; member perks. Cancel anytime.' + more;
        }
      }
    }
  }
  function notifyCart() {
    try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'ce-membership-upsell' } })); } catch (e) {}
  }
  function refresh() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      lastCart = c; ensureTable(); applyState(); updateBubble();
      if (CC_AUTO_ADD && !busy && realCount(c) > 0 && !membershipInCart(c) && !autoAddDone()) { markAutoAdd(); addMembership(); }
    }).catch(function () {});
  }

  function rerenderCart() {
    // Re-render the drawer's cart-items-component (lines + summary/total) from the
    // section, so the live discount shows immediately. Theme's own cart events don't
    // fire for our raw AJAX changes, so we refresh the section ourselves.
    var comp = document.querySelector('cart-items-component[data-section-id]');
    if (!comp) return Promise.resolve();
    var sid = comp.getAttribute('data-section-id');
    return fetch('/?section_id=' + encodeURIComponent(sid), { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (htmlStr) {
        try {
          var doc = new DOMParser().parseFromString(htmlStr, 'text/html');
          var fresh = doc.querySelector('cart-items-component');
          var cur = document.querySelector('cart-items-component[data-drawer]') || comp;
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        } catch (e) {}
      }).catch(function () {});
  }
  function afterChange() {
    return rerenderCart()
      .then(function () { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); })
      .then(function (c) { lastCart = c; busy = false; ensureTable(); applyState(); updateBubble(); notifyCart(); })
      .catch(function () { busy = false; refresh(); });
  }
  function addMembership() {
    if (busy || membershipInCart(lastCart)) return; busy = true; applyState();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: MEMBERSHIP_VARIANT, quantity: 1, selling_plan: SELLING_PLAN }] }) })
      .then(afterChange).catch(function () { busy = false; refresh(); });
  }
  function removeMembership() {
    var key = membershipKey(lastCart);
    if (busy || !key) { busy = false; applyState(); return; } busy = true; applyState();
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(afterChange).catch(function () { busy = false; refresh(); });
  }
  function setMember(on) {
    if (busy) { applyState(); return; }
    markAutoAdd();
    if (on) addMembership(); else removeMembership();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cct-toggle]');
    if (t) { if (lastCart && realCount(lastCart) === 0) return; var body = t.closest('.ce-cct').querySelector('.ce-cct__body'); var open = t.getAttribute('aria-expanded') === 'true'; t.setAttribute('aria-expanded', String(!open)); if (body) body.style.display = open ? 'none' : ''; return; }
    var pill = e.target.closest && e.target.closest('[data-cc-member]');
    if (pill) { setMember(pill.getAttribute('data-cc-member') === '1'); }
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-cc-box')) setMember(e.target.checked);
  });

  var deb;
  try { new MutationObserver(function () { if (busy) return; clearTimeout(deb); deb = setTimeout(refresh, 250); }).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
